
import React from 'react';

import Icon from '../icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

const ViewParentsGoToLink = ({url}: {url:string}) => (
    <a href={url} style={{display: 'flex'}}>
        <span style={{marginRight: '5px'}}>Go to List</span>
        <Icon iconName={IconLibrary.EXTERNAL_LINK} color='#0570B6' sizeInPx='12'/>
    </a>
)

export default ViewParentsGoToLink